/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.taxation.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.taxation = {};
proto.witbooking.backoffice.taxation.v1 = require('./taxation_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest,
 *   !proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse>}
 */
const methodDescriptor_TaxationAPI_CreateTaxation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.taxation.v1.TaxationAPI/CreateTaxation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest,
  proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest,
 *   !proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse>}
 */
const methodInfo_TaxationAPI_CreateTaxation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIClient.prototype.createTaxation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/CreateTaxation',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_CreateTaxation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIPromiseClient.prototype.createTaxation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/CreateTaxation',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_CreateTaxation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest,
 *   !proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse>}
 */
const methodDescriptor_TaxationAPI_UpdateTaxation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.taxation.v1.TaxationAPI/UpdateTaxation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest,
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest,
 *   !proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse>}
 */
const methodInfo_TaxationAPI_UpdateTaxation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIClient.prototype.updateTaxation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/UpdateTaxation',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_UpdateTaxation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIPromiseClient.prototype.updateTaxation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/UpdateTaxation',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_UpdateTaxation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest,
 *   !proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse>}
 */
const methodDescriptor_TaxationAPI_DeleteTaxation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.taxation.v1.TaxationAPI/DeleteTaxation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest,
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest,
 *   !proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse>}
 */
const methodInfo_TaxationAPI_DeleteTaxation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIClient.prototype.deleteTaxation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/DeleteTaxation',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_DeleteTaxation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIPromiseClient.prototype.deleteTaxation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/DeleteTaxation',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_DeleteTaxation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.taxation.v1.GetTaxationRequest,
 *   !proto.witbooking.backoffice.taxation.v1.GetTaxationResponse>}
 */
const methodDescriptor_TaxationAPI_GetTaxation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.taxation.v1.TaxationAPI/GetTaxation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.taxation.v1.GetTaxationRequest,
  proto.witbooking.backoffice.taxation.v1.GetTaxationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.taxation.v1.GetTaxationRequest,
 *   !proto.witbooking.backoffice.taxation.v1.GetTaxationResponse>}
 */
const methodInfo_TaxationAPI_GetTaxation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.taxation.v1.GetTaxationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.taxation.v1.GetTaxationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIClient.prototype.getTaxation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/GetTaxation',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_GetTaxation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIPromiseClient.prototype.getTaxation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/GetTaxation',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_GetTaxation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest,
 *   !proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse>}
 */
const methodDescriptor_TaxationAPI_FindTaxations = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.taxation.v1.TaxationAPI/FindTaxations',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest,
  proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest,
 *   !proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse>}
 */
const methodInfo_TaxationAPI_FindTaxations = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIClient.prototype.findTaxations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/FindTaxations',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_FindTaxations,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.taxation.v1.TaxationAPIPromiseClient.prototype.findTaxations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.taxation.v1.TaxationAPI/FindTaxations',
      request,
      metadata || {},
      methodDescriptor_TaxationAPI_FindTaxations);
};


module.exports = proto.witbooking.backoffice.taxation.v1;

